import "%modules%/header/header";
import "%modules%/product/product";
import "%modules%/reviews/reviews";
import "%modules%/footer/footer";
import "%modules%/comments/comments";